import React, { Fragment, useState, useEffect, useLayoutEffect, useCallback } from "react";
import SingleQuery from "./singlequery/SingleQuery";
import QueryService from "../../services/QueryService";
import { stateData, gender } from "../../constants/data";
import GPASlider from "./gpa_slider/GPA_SLIDER.js";
import { useHistory, useLocation } from "react-router";
import AdvanceQueryCriteria from "./advanceQuery/AdvanceQuery";
import DistrictSchoolSelector from "./advanceQuery/DistrictSchoolSelector";
import "./advanceQuery/AdvanceQueryModal.css";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import CustomLoader from "../../components/customLoader/CustomLoader";
import SaveModal from "../../components/saveModal/SaveModal";
import ConfirmationDialog from "../../components/confirmationModalForSiembra/ConfirmationModalForSiembra";
import ErrorModal from "../../components/errorDisplayModal/ErrorDisplayModal";
import _ from "lodash";
import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import { useDispatch, useSelector } from "react-redux";
import { changeQueryLocation } from "../../reducers/locationReducer";
import { Opacity } from "@material-ui/icons";

const sfgv = {
  name: "Student First Generation",
  value: "student first generation",
  Selected: false,
};

const ucGreen = {
  name: "A-G On Track Students",
  value: "uc_status",
  Selected: false,
};

const gradeData = [
  { value: "09", name: "Freshman" },
  { value: "10", name: "Sophomore" },
  { value: "11", name: "Junior" },
  { value: "12", name: "Senior" },
  { value: "alumni", name: "alumni" },
];
const QueryComponent = () => {
  const gradeFromData = _.cloneDeep(gradeData);
  console.log("gradeFromData", gradeData, gradeFromData);
  const stateOfCountry = _.cloneDeep(stateData);
  // Clone global gender and extend for H/S query with separate Non-Binary vs Unknown
  const baseGenderData = JSON.parse(JSON.stringify(gender));
  const genderData = baseGenderData
    .map((g) => (g.name === "Non-Binary" ? { ...g, value: "non-binary" } : g));
  genderData.push({ name: "Unknown", value: "unknown", send: "Unknown" });
  const cloneDataForUC = _.cloneDeep(ucGreen);
  const cloneDataForFirstGeneration = _.cloneDeep(sfgv);
  let history = useHistory();
  let location = useLocation();

  const dispatch = useDispatch();
  const queryData = useSelector((state) => state?.locationReducer?.query);
  console.log("dataQuery11", queryData);
  const [inputValueForSave, setInputValueForSave] = useState("");
  const [selectedTab, setSelectedTab] = useState("customQuery");
  const [selectedQueries, setSelectedQueries] = useState([]);
  const [ethnicity, setEthnicityData] = useState();
  const [showEthData, setShowEthData] = useState();
  const [showStateData, setShowStateData] = useState(stateOfCountry);
  const [valueWhichExpand, setValueWhichExpanded] = useState();
  const [grade, setGrade] = useState(gradeFromData);
  const [academicsData, setAcademicsData] = useState();
  const [showAcademicsData, setShowAcademicsData] = useState();
  const [activitiesData, setActivitiesData] = useState();
  const [showActivitiesData, setShowActivitiesData] = useState();
  const [athleticsData, setAthleticsData] = useState();
  const [showAthleticsData, setShowAthleticsData] = useState();
  const [interestData, setInterestData] = useState();
  const [showInterestData, setShowInterestData] = useState();
  const [stemData, setStemData] = useState();
  const [selectedStateQueries, setSelectedStateQueries] = useState([]);
  const [selectedEthnicityQueries, setSelectedEthnicityQueries] = useState([]);
  const [configObject, setConfigObject] = useState([]);
  const [selectedGradeQueries, setSelectedGradeQueries] = useState([]);
  const [selectedAcademicsQueries, setSelectedAcademicsQueries] = useState([]);
  const [selectedAthleticsQueries, setSelectedAthleticsQueries] = useState([]);
  const [selectedActivitiesQueries, setSelectedActivitiesQueries] = useState(
    []
  );
  const [selectedInterestsQueries, setSelectedInterestsQueries] = useState([]);
  const [selectedStemQueries, setSelectedStemQueries] = useState([]);
  const [genderValue, setGenderValue] = useState();
  const [minGPA, setMinGPA] = useState(0);
  const [maxGPA, setMaxGPA] = useState(4);
  const [openAdvanceQuerySection, setOpenAdvanceQuerySection] = useState(false);
  const [openAdvanceQueryModal, setOpenAdvanceQueryModal] = useState(false);
  const [selectedThirdParameter, setSelectedThirdParameter] = useState([]);
  const [noOfAdvanceQuery, setNoOfAdvanceQuery] = useState([]);
  const [advanceQueryCount, setAdvanceQueryCount] = useState(0);
  const [queryResultData, setQueryResultData] = useState();
  const [openSaveQueryModal, setOpenSaveQueryModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openConfirmationForSiembra, setOpenConfirmationForSiembra] = useState(
    false
  );
  const [
    studentFirstGenerationValue,
    setStudentFirstGenerationValue,
  ] = useState(cloneDataForFirstGeneration);
  const [studentFirstGeneration, setStudentFirstGeneration] = useState(false);
  const [ucGreenRequirement, setUCGreenRequirement] = useState(false);
  const [ucGreenRequirementValue, setUCGreenRequirementValue] = useState(
    cloneDataForUC
  );
  const [queryTittle, setQueryTittle] = useState();
  const [viewQueryData, setViewQueryData] = useState([queryData && queryData]);
  const user = useSelector((state) => state?.UserReducer?.userObj);
  const [openExistingErrorModal, setOpenExistingErrorModal] = useState();
  const [schoolData, setSchoolData] = useState();
  const [districtData, setDistrictData] = useState([]);
  // const [page, setPage] = useState(1);
  const [config, setConfig] = useState([]);
  console.log("user", user);

  const getDetails = () => {
    let obj = {
      student_id: user?.id,
      role: user?.role,
      school_id: user?.college,
      device_type: "web",
      mobile_os: "null",
      app_version: "null",
    };
    QueryService.getDetails(obj).then((data) => {
      console.log("history data", data);
    });
  };

  useEffect(() => {
    getDetails();
  }, [user?.id, user?.role, user?.college]);

  useEffect(() => {
    if (location.state?.someValue) {
      setQueryTittle(location.state?.someValue);
    }
  }, [location]);

  const checkViewQuery = () => {
    console.log("viewQuery", viewQueryData);
    if (viewQueryData && viewQueryData.length > 0) {
      let array = [];
      viewQueryData[0] &&
        viewQueryData?.map((item, index) => {
          console.log("sale", item?.sfg);

          //   for (const [key, value] of Object.entries(item)) {
          //     array.push(value);
          //   }
          //   return array;
          // });
          // array.map((item) => {
          if (item.gender === "Male" || item.gender === "M" || item.gender === "m") {
            let selectedGender =
              genderData && genderData.filter((item) => item.value === "male");
            handleGenderCheckbox(selectedGender[0]);
          } else if (item.gender === "Female" || item.gender === "F" || item.gender === "f") {
            let selectedGender =
              genderData &&
              genderData.filter((item) => item.value === "female");
            handleGenderCheckbox(selectedGender[0]);
          } else if (item.gender === "Non-Binary" || item.gender === "U" || item.gender === "u") {
            let selectedGender =
              genderData &&
              genderData.filter((item) => item.value === "non-binary");
            handleGenderCheckbox(selectedGender[0]);
          } else if (item.gender === "Unknown" || item.gender === "unknown") {
            let selectedGender =
              genderData &&
              genderData.filter((item) => item.value === "unknown");
            handleGenderCheckbox(selectedGender[0]);
          }
          if (item?.state && item?.state?.length > 0) {
            item?.state?.map((v) =>
              handleCheckBox({ name: v, value: v }, "contains", "state")
            );
          }
          if (item?.ethnicity && item?.ethnicity?.length > 0) {
            item?.ethnicity?.map((v) =>
              handleCheckBox({ name: v, value: v }, "contains", "ethnicity")
            );
          }
          if (item?.sfg === true) {
            handleCheckBox(
              studentFirstGenerationValue,
              "contains",
              "student first generation"
            );
          }
          if (item?.status === true) {
            handleCheckBox(ucGreenRequirementValue, "contains", "uc_status");
          }
          if (item?.academics && item?.academics?.length > 0) {
            item.academics.map((v) =>
              handleCheckBox({ name: v, value: v }, "contains", "academics")
            );
          }
          if (item?.athletics && item?.athletics?.length > 0) {
            item.athletics.map((v) =>
              handleCheckBox({ name: v, value: v }, "contains", "athletics")
            );
          }
          if (item?.interests && item?.interests?.length > 0) {
            item.interests.map((v) =>
              handleCheckBox({ name: v, value: v }, "contains", "interests")
            );
          }
          if (item?.activities && item?.activities?.length > 0) {
            item.activities.map((v) =>
              handleCheckBox({ name: v, value: v }, "contains", "activities")
            );
          }
          if (item?.grade && item?.grade?.length > 0) {
            item.grade.map((v) => {
              handleCheckBox({ name: v, value: v }, "contains", "grade");
            });
          }
          if (item?.proficiency && item?.proficiency?.length > 0) {
            item.proficiency.map((v) => {
              handleCheckBox(
                { name: v, value: v },
                "contains",
                "subject matter proficiency"
              );
            });
          }

          if (item?.gpa) {
            setMinGPA(item?.gpa?.min);
            setMaxGPA(item?.gpa?.max);
          }
        });
    }
  };

  useLayoutEffect(() => {
    if (viewQueryData && viewQueryData.length > 0) {
      checkViewQuery();
    }
  }, [viewQueryData]);

  const resetQueryCriteria = () => {
    window.location.reload();
    dispatch(changeQueryLocation({}));
  };

  const saveForSiembra = () => {
    setOpenConfirmationForSiembra(true);
    setOpenSaveQueryModal(false);
  };

  const onCloseAdvanceQuery = async (index) => {
    let v = noOfAdvanceQuery[index];
    let removeValue = noOfAdvanceQuery.filter((i) => i !== v);
    setNoOfAdvanceQuery(removeValue);
    
    // Remove from configObject without mutating state
    setConfigObject(prev => {
      const newConfig = [...prev];
      newConfig.splice(index, 1);
      return newConfig;
    });
  };

  const createConfig = (conf, operator = "contains", value) => {
    console.log("value from the createConfig", value);
    
    const existingConfigIndex = configObject.findIndex(
      (element) => element && element.config.value === conf.value
    );

    if (existingConfigIndex >= 0) {
      // Update existing config without mutation
      setConfigObject(prev => {
        const newConfig = [...prev];
        newConfig[existingConfigIndex] = {
          ...newConfig[existingConfigIndex],
          multi_value: value
        };
        return newConfig;
      });
    } else {
      if (conf && (value || value === "")) {
        let configObj = {
          fromServer: true,
          parentResource: null,
          reqParams: null,
          restangularCollection: false,
          route: "configure",
        };
        let obj = {};
        obj.config = { ...conf, ...configObj };
        obj.multi_value =
          conf.value !== "overall gpa" &&
          conf.value !== "student first generation" &&
          conf.value !== "zip code" &&
          conf.value !== "uc_status"
            ? value
            : [];
        obj.level = 0;
        obj.margin = "margin";
        obj.operator =
          operator === "not" ? "not" : operator === null ? null : "contains";
        obj.query_exp_id = "";
        obj.range_value = conf.value === "overall gpa" ? [value] : [];
        obj.selected_item = [];
        obj.parent = [];
        obj.value =
          conf && conf.value === "student first generation"
            ? "student first generation"
            : conf?.value === "uc_status"
            ? "uc_status"
            : "";
        setConfigObject((prevItems) => [...prevItems, obj]);
      }
    }
  };

  const createConfigForGPAAdvance = (conf, operator = "contains", value) => {
    console.log("conf from gpa", conf);
    console.log("val", value);
    
    const existingConfigIndex = configObject.findIndex(
      (element) => element && element?.config?.value === conf?.value
    );

    if (existingConfigIndex >= 0) {
      // Update existing config without mutation
      setConfigObject(prev => {
        const newConfig = [...prev];
        const element = newConfig[existingConfigIndex];
        
        if (typeof value === "object") {
          newConfig[existingConfigIndex] = {
            ...element,
            range_value: value ? [value] : []
          };
        } else if (typeof value === "string") {
          newConfig[existingConfigIndex] = {
            ...element,
            value: value
          };
        }
        return newConfig;
      });
    } else {
      if (conf && value) {
        let configObj = {
          fromServer: true,
          parentResource: null,
          reqParams: null,
          restangularCollection: false,
          route: "configure",
        };
        let obj = {};
        obj.config = { ...configObj, ...conf };
        obj.multi_value = [];
        obj.level = 0;
        obj.margin = "margin";
        obj.operator = operator;
        obj.query_exp_id = "";
        obj.range_value = typeof value === "object" ? [value] : [];
        obj.selected_item = [];
        obj.parent = [];
        obj.value = typeof value === "string" ? value : [];
        setConfigObject((prevItems) => [...prevItems, obj]);
      }
    }
  };

  const clearAll = () => {
    setSelectedThirdParameter([]);
  };
  const createConfigForGender = (conf, operator, value, from) => {
    const hasExistingConfig = configObject &&
      configObject.some(
        (element) => element && element.config.value === conf.value
      ) &&
      from === "not-advance-query";

    console.log(hasExistingConfig);

    if (hasExistingConfig) {
      const existingConfigIndex = configObject.findIndex(
        (element) => element && element.config.value === conf.value
      );
      
      if (existingConfigIndex >= 0) {
        setConfigObject(prev => {
          const newConfig = [...prev];
          newConfig[existingConfigIndex] = {
            ...newConfig[existingConfigIndex],
            value: value && value.value === "male"
              ? "m"
              : value.value === "female"
              ? "f"
              : value.value === "non-binary"
              ? "u"
              : "unknown"
          };
          return newConfig;
        });
      }
    } else {
      if (conf && value) {
        let configObj = {
          fromServer: true,
          parentResource: null,
          reqParams: null,
          restangularCollection: false,
          route: "configure",
        };
        let obj = {};
        obj.config = { ...configObj, ...conf };
        obj.multi_value = [];
        obj.level = 0;
        obj.margin = "margin";
        obj.operator = operator;
        obj.parent = [];
        obj.query_exp_id = "";
        obj.range_value = [];
        obj.selected_item = [];
        obj.value =
          value && value.value === "male"
            ? "m"
            : value.value === "female"
            ? "f"
            : value.value === "non-binary"
            ? "u"
            : "unknown";
        setConfigObject((prevItems) => [...prevItems, obj]);
      }
    }
  };

  const removeValue = async (value, config, selectedThirdParameter) => {
    if (value.hasOwnProperty("Selected") && value["Selected"] === true) {
      if (selectedQueries && selectedQueries.length > 0) {
        let removedValueFromFilter = selectedQueries.filter(
          (i) => i.query.name !== value.name
        );
        setSelectedQueries(removedValueFromFilter);
      }
    }
    value["Selected"] = false;
    if (selectedThirdParameter && selectedThirdParameter.length > 0) {
      setSelectedThirdParameter(prev => prev.filter(element => 
        element !== value && 
        !(value.name === element.label && value.id === element.value)
      ));
    }
    configObject &&
      configObject.map(async (element) => {
        if (element.config.value === "student first generation") {
          let index =
            configObject &&
            configObject.filter(
              (item) => item.config.value !== "student first generation"
            );
          //console.log("index from the Student First Generation" , index);
          await setConfigObject(index);
        } else if (element.config.value === "uc_status") {
          let index =
            configObject &&
            configObject.filter((item) => item.config.value !== "uc_status");
          //console.log("index from the Student First Generation" , index);
          await setConfigObject(index);
        } else if (element.config.value && config.value === "state") {
          setSelectedStateQueries(prev => prev.filter(item => item !== value));
        } else if (element.config.value && config.value === "ethnicity") {
          setSelectedEthnicityQueries(prev => prev.filter(item => item !== value));
        } else if (element.config.value && config.value === "grade") {
          setSelectedGradeQueries(prev => prev.filter(item => item.value !== value.value));
        } else if (element.config.value && config.value === "athletics") {
          setSelectedAthleticsQueries(prev => prev.filter(item => item.id !== value.id));
        } else if (element.config.value && config.value === "academics") {
          setSelectedAcademicsQueries(prev => prev.filter(item => item.id !== value.id));
        } else if (element.config.value && config.value === "activities") {
          setSelectedActivitiesQueries(prev => prev.filter(item => item.id !== value.id));
        } else if (element.config.value && config.value === "interests") {
          setSelectedInterestsQueries(prev => prev.filter(item => item.id !== value.id));
        }
        if (
          config.value !== "grade" &&
          config.value !== "state" &&
          config.value === element.config.value &&
          element.multi_value.length > 0
        ) {
          element.multi_value.splice(
            element.multi_value.findIndex(
              (subelement) => subelement.id === value.id
            ),
            1
          );
        }
        if (config.value === "grade") {
          if (
            config.value === element.config.value &&
            element.multi_value.length > 0
          ) {
            let index = element.multi_value.filter(
              (item) => item.value !== value.value
            );
            element.multi_value = index;
          }
        }
        if (config.value === "state") {
          if (
            config.value === element.config.value &&
            element.multi_value.length > 0
          ) {
            let index = element.multi_value.filter(
              (item) => item.code !== value.code && item.Selected === true
            );
            element.multi_value = index;
          }
        }

      });
    
    // Remove empty config objects without mutation
    setConfigObject(prev => prev.filter(element => 
      element.config.value === "gender" || 
      (element.multi_value && element.multi_value.length > 0)
    ));
  };

  let selected;
  const handleCheckBox = async (value, operator = "contains", type, fromAdvance = false) => {
    console.log("from the handle check box", value, operator, type);
    selected = value;
    if (type === "grade" && value.hasOwnProperty("label")) {
      let modifiedObjForGrade = {
        value: value?.value,
        name: value?.label,
      };
      value = modifiedObjForGrade;
    }
  let originalElement = {};
    let finalValue = {};
    let objectValue = {};
    let multiValue = [];
    let selectedQueryFromView = [];
    if (
      !selected?.hasOwnProperty("Selected") ||
      selected?.["Selected"] === false
    ) {
      // Build objects to push into chips list
      const toPush = [];
      if (type === "high school" && Array.isArray(selected)) {
        selected.forEach((sch) => {
          toPush.push({ query: sch, type, source: fromAdvance ? "advance" : "basic" });
        });
      } else {
        toPush.push({ query: selected, type, source: fromAdvance ? "advance" : "basic" });
      }
      if (toPush.length) {
        await setSelectedQueries((prev) => {
          // de-duplicate by type+query.name or type+query.id
          const next = [...prev];
          toPush.forEach((item) => {
            const qName = item.query?.name || item.query?.stem_name;
            const qId = item.query?.id;
            const exists = next.some((e) => e.type === item.type && ((qId && e.query?.id === qId) || (!qId && (e.query?.name === qName || e.query?.stem_name === qName))));
            if (!exists) next.push(item);
          });
          return next;
        });
      }
    }
    if (selected?.hasOwnProperty("Selected") && selected["Selected"] === true) {
      if (selectedQueries && selectedQueries.length > 0) {
        let removedValueFromFilter = selectedQueries.filter(
          (i) => i.query.name !== selected.name
        );
        setSelectedQueries(removedValueFromFilter);
      }
    }
    // Special handling for removing a single selected High School via chip X
    if (type === "high school" && selected && !Array.isArray(selected) && (!selected?.Selected || selected?.Selected === false)) {
      // Remove from chips
      setSelectedQueries((prev) => prev.filter((i) => !(i.type === "high school" && i?.query?.id === selected?.id)));
      // Update schoolData and config
      if (Array.isArray(schoolData) && schoolData.length > 0) {
        const updatedSchools = schoolData.filter((s) => s.id !== selected.id);
        setSchoolData(updatedSchools);
        const conf = config && config.filter((item) => item.value === "high school");
        if (conf) createConfig(conf, operator, updatedSchools);
      }
      return;
    }
    if (
      type === "interests" ||
      type === "academics" ||
      type === "activities" ||
      type === "athletics"
    ) {
      selected.id = selected.id || selected.value || selected.name;
      selected.name = selected.label || selected.name;
      if (selected.Selected === true) {
        selected.Selected = true;
      }
      originalElement = selected;
      finalValue = { ...selected, originalElement };
    }
    if (type === "state") {
      let conf = config && config.filter((item) => item.value === "state");
      if (
        !selected.hasOwnProperty("Selected") ||
        selected["Selected"] === false
      ) {
        selected["Selected"] = true;
        multiValue.push(value);
        await setSelectedStateQueries([...selectedStateQueries, ...multiValue]);
        createConfig(conf, operator, [...selectedStateQueries, ...multiValue]);
      } else {
        removeValue(value, conf, selectedStateQueries);
      }
    } else if (type === "ethnicity") {
      let conf = config && config.filter((item) => item.value === "ethnicity");
      if (
        !selected.hasOwnProperty("Selected") ||
        selected["Selected"] === false
      ) {
        selected["Selected"] = true;
        multiValue.push(selected);
        setSelectedEthnicityQueries([
          ...selectedEthnicityQueries,
          ...multiValue,
        ]);
        createConfig(conf && conf, operator, [
          ...selectedEthnicityQueries,
          ...multiValue,
        ]);
      } else {
        removeValue(selected, conf, selectedEthnicityQueries);
      }
    } else if (type === "grade") {
      let conf = config && config.filter((item) => item.value === "grade");
      if (
        !selected.hasOwnProperty("Selected") ||
        selected["Selected"] === false
      ) {
        selected["Selected"] = true;
        multiValue.push(selected);
        setSelectedGradeQueries([...selectedGradeQueries, ...multiValue]);
        createConfig(conf, operator, [...selectedGradeQueries, ...multiValue]);
      } else {
        removeValue(selected, conf, selectedGradeQueries);
      }
    } else if (type === "academics") {
      let conf = config && config.filter((item) => item.value === "academics");
      if (
        !selected.hasOwnProperty("Selected") ||
        selected["Selected"] === false
      ) {
        selected["Selected"] = true;
        multiValue.push(selected);
        setSelectedAcademicsQueries([
          ...selectedAcademicsQueries,
          ...multiValue,
        ]);
        createConfig(conf, operator, [
          ...selectedAcademicsQueries,
          ...multiValue,
        ]);
      } else {
        removeValue(selected, conf, selectedAcademicsQueries);
      }
    } else if (type === "activities") {
      let conf = config && config.filter((item) => item.value === "activities");
      if (
        !selected.hasOwnProperty("Selected") ||
        selected["Selected"] === false
      ) {
        selected["Selected"] = true;
        multiValue.push(selected);
        setSelectedActivitiesQueries([
          ...selectedActivitiesQueries,
          ...multiValue,
        ]);
        createConfig(conf, operator, [
          ...selectedActivitiesQueries,
          ...multiValue,
        ]);
      } else {
        removeValue(selected, conf, selectedActivitiesQueries);
      }
    } else if (type === "athletics") {
      let conf = config && config.filter((item) => item.value === "athletics");
      if (
        !selected.hasOwnProperty("Selected") ||
        selected["Selected"] === false
      ) {
        selected["Selected"] = true;
        multiValue.push(selected);
        setSelectedAthleticsQueries([
          ...selectedAthleticsQueries,
          ...multiValue,
        ]);
        createConfig(conf, operator, [
          ...selectedAthleticsQueries,
          ...multiValue,
        ]);
      } else {
        removeValue(selected, conf, selectedAthleticsQueries);
      }
    } else if (type === "interests") {
      let conf = config && config.filter((item) => item.value === "interests");
      if (
        !selected.hasOwnProperty("Selected") ||
        selected["Selected"] === false
      ) {
        selected["Selected"] = true;
        multiValue.push(selected);
        setSelectedInterestsQueries([
          ...selectedInterestsQueries,
          ...multiValue,
        ]);
        createConfig(conf, operator, [
          ...selectedInterestsQueries,
          ...multiValue,
        ]);
      } else {
        removeValue(selected, conf, selectedInterestsQueries);
      }
    } else if (type === "subject matter proficiency") {
      let conf =
        config &&
        config.filter((item) => item.value === "subject matter proficiency");
      if (
        !selected.hasOwnProperty("Selected") ||
        selected["Selected"] === false
      ) {
        console.log("selected", selected);
        selected["Selected"] = true;
        // selected["name"] = selected?.stem_name;
        // selected["stem_name"] = selected?.stem_name;
        multiValue.push(selected);
        console.log("selected", selected);
        console.log("multiValue", multiValue);

        setSelectedStemQueries([...selectedStemQueries, ...multiValue]);
        createConfig(conf, operator, [...selectedStemQueries, ...multiValue]);
      } else {
        removeValue(selected, conf, selectedStemQueries);
      }
    } else if (type === "student first generation") {
      let conf =
        config &&
        config.filter((item) => item.value === "student first generation");
      if (
        !selected.hasOwnProperty("Selected") ||
        selected["Selected"] === false
      ) {
        selected["Selected"] = true;
        await setStudentFirstGeneration(true);
        createConfig(conf, operator, studentFirstGenerationValue);
      } else {
        setStudentFirstGeneration(false);
        removeValue(
          studentFirstGenerationValue,
          conf,
          studentFirstGenerationValue
        );
      }
      // createConfig(conf[0], operator, "student first generation")
    } else if (type === "uc_status") {
      let conf = config && config.filter((item) => item.value === "uc_status");
      if (
        !selected.hasOwnProperty("Selected") ||
        selected["Selected"] === false
      ) {
        selected["Selected"] = true;
        await setUCGreenRequirement(true);
        createConfig(conf, operator, ucGreenRequirementValue);
      } else {
        setUCGreenRequirement(false);
        removeValue(ucGreenRequirementValue, conf, ucGreenRequirementValue);
      }
      // createConfig(conf[0], operator, "student first generation")
    } else if (type === "high school" && Array.isArray(selected) === true) {
      if (selected.length > 0) {
        let conf =
          config && config.filter((item) => item.value === "high school");
        createConfig(conf, operator, selected);
        setSchoolData(selected);
        // Ensure chips reflect all selected schools
        setSelectedQueries((prev) => {
          const next = [...prev];
          selected.forEach((sch) => {
            const exists = next.some((i) => i.type === "high school" && i?.query?.id === sch.id);
            if (!exists) next.push({ query: sch, type: "high school", source: fromAdvance ? "advance" : "basic" });
          });
          return next;
        });
      }
    } else if (type === "district" && Array.isArray(selected) === true) {
      if (selected.length > 0) {
        let conf =
          config && config.filter((item) => item.value === "district");
        createConfig(conf, operator, selected);
        setDistrictData(selected);
        // Ensure chips reflect all selected districts
        setSelectedQueries((prev) => {
          const next = [...prev];
          selected.forEach((dist) => {
            const exists = next.some((i) => i.type === "district" && i?.query?.id === dist.id);
            if (!exists) next.push({ query: dist, type: "district", source: fromAdvance ? "advance" : "basic" });
          });
          return next;
        });
      }
    } else if (type === "school district" && Array.isArray(selected) === true) {
      if (selected.length > 0) {
        let conf =
          config && config.filter((item) => item.value === "school district");
        createConfig(conf, operator, selected);
        setDistrictData(selected);
        // Ensure chips reflect all selected school districts
        setSelectedQueries((prev) => {
          const next = [...prev];
          selected.forEach((dist) => {
            const exists = next.some((i) => i.type === "school district" && i?.query?.id === dist.id);
            if (!exists) next.push({ query: dist, type: "school district", source: fromAdvance ? "advance" : "basic" });
          });
          return next;
        });
      }
    } else if (type === "gender" && selected) {
      if (selected.Selected === true) {
        removeValueForCheckBox(selected);
        return;
      }
      handleGenderCheckbox(selected, operator, "advance-query");
    } else if (type === "zip code") {
      let conf = config && config.filter((item) => item.value === "zip code");
      createConfig(conf, operator, "");
    }
  };

  const onShowMore = async () => {};

  // const getAcademics = () => {
  //   const body = {
  //     list_name: "academics",
  //   };
  //   setLoading(true);
  //   QueryService.getAcademics(body)
  //     .then((data) => {
  //       setLoading(false);

  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       console.log("error frm the service", error);
  //     });
  // };

  // const getStem = () => {
  //   const body = {
  //     list_name: "stem",
  //   };
  //   setLoading(true);
  //   QueryService.getStemData(body)
  //     .then((data) => {
  //       setLoading(false);

  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       console.log("error frm the service", error);
  //     });
  // };

  // const getActivities = () => {
  //   const body = {
  //     list_name: "activities",
  //   };
  //   setLoading(true);
  //   QueryService.getActivities(body)
  //     .then((data) => {
  //       setLoading(false);

  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       console.log("error frm the service", error);
  //     });
  // };

  // const getAthletics = () => {
  //   const body = {
  //     list_name: "athletics",
  //   };
  //   setLoading(true);
  //   QueryService.getAthletics(body)
  //     .then((data) => {
  //       setLoading(false);

  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       console.log("error frm the service", error);
  //     });
  // };

  // const getInterest = () => {
  //   const body = {
  //     list_name: "intrest",
  //   };
  //   setLoading(true);
  //   QueryService.getInterest(body)
  //     .then((data) => {
  //       setLoading(false);

  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       console.log("error frm the service", error);
  //     });
  // };

  const getSchoolData = () => {
    setLoading(true);
    QueryService.getLatestConfig()
      .then((data) => {
        setLoading(false);
        let AllAcademics = data?.data?.object?.academics;
        let AllEthnicities = data?.data?.object?.ethnicity;
        let AllActivities = data?.data?.object?.activities;
        let AllAthletics = data?.data?.object?.athletics;
        let AllIntrest = data?.data?.object?.intrest;
        let AllProficiency = data?.data?.object?.steam;

        let AllCriteriamanual = data?.data?.objects?.query_criteriamanual;
        let AllCriteria = data?.data?.objects?.query_criteria;

  setEthnicityData(AllEthnicities);
  setShowEthData(AllEthnicities);
  setInterestData(AllIntrest);
  setShowInterestData(AllIntrest);
  setAthleticsData(AllAthletics);
  setShowAthleticsData(AllAthletics);
  setActivitiesData(AllActivities);
  setShowActivitiesData(AllActivities);
  setAcademicsData(AllAcademics);
  setShowAcademicsData(AllAcademics);
        setStemData(AllProficiency);

        setConfig(AllCriteriamanual);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error from the service", error);
      });
  };
  // console.log(ethnicity);
  // console.log("dataeth",showEthData);
  // const getConfig = () => {
  //   QueryService.getConfigData()
  //     .then((data) => {
  //       console.log("data from the config service", data);

  //     })
  //     .catch((error) => {
  //       console.log("error from the service", error);
  //     });
  // };

  useEffect(() => {
    getSchoolData();
    // getAcademics();
    // getActivities();
    // getAthletics();
    // getInterest();
    // getStem();
    // getConfig();
    // return () => {
    //   setViewQueryData([]);
    // };
  }, []);

  // console.log("gg",stateOfCountry.map((state) => state.name));

  let stateValue;
  const stateVal = () => {
    stateValue = selectedStateQueries.map((item) => item.name);
  };
  if (selectedStateQueries.length > 0) {
    stateVal();
  }

  let ethnicityValue;
  const ethnicityVal = () => {
    ethnicityValue = selectedEthnicityQueries.map((item) => item.name);
  };
  if (selectedEthnicityQueries.length > 0) {
    ethnicityVal();
  }

  let gradeValue;
  const gradeVal = () => {
    gradeValue = selectedGradeQueries.map((item) => item.name);
  };
  if (selectedGradeQueries.length > 0) {
    gradeVal();
  }

  let academicsValue;
  const academicsVal = () => {
    academicsValue = selectedAcademicsQueries.map((item) => item.name);
  };
  if (selectedAcademicsQueries.length > 0) {
    academicsVal();
  }

  let activitesValue;
  const activitesVal = () => {
    activitesValue = selectedActivitiesQueries.map((item) => item.name);
  };
  if (selectedActivitiesQueries.length > 0) {
    activitesVal();
  }

  let athleticsValue;
  const athleticsVal = () => {
    athleticsValue = selectedAthleticsQueries.map((item) => item.name);
  };
  if (selectedAthleticsQueries.length > 0) {
    athleticsVal();
  }

  let interestsValue;
  const interestsVal = () => {
    interestsValue = selectedInterestsQueries.map((item) => item.name);
  };
  if (selectedInterestsQueries.length > 0) {
    interestsVal();
  }

  let smpValue;
  const smpVal = () => {
    smpValue = selectedStemQueries.map((item) => item.name);
  };
  if (selectedStemQueries.length > 0) {
    smpVal();
  }

  let gpaVal;
  if (minGPA !== 0 || maxGPA !== 4) {
    gpaVal = { min: minGPA, max: maxGPA };
  } else if (minGPA > 0 || maxGPA > 4) {
    gpaVal = { min: minGPA, max: maxGPA };
  }

  let overQuery = {
    gender: genderValue && genderValue?.send,
    // gender: [genderValue && genderValue?.send]),
    state: stateValue,
    ethnicity: ethnicityValue,
    gpa: gpaVal,
    grade: gradeValue,
    academics: academicsValue,
    activities: activitesValue,
    athletics: athleticsValue,
    interests: interestsValue,
    proficiency: smpValue,
    // school:[]
  };
  if (studentFirstGeneration) {
    overQuery.sfg = studentFirstGeneration;
  }
  if (ucGreenRequirement) {
    overQuery.status = true; // Explicitly pass true when A-G On Track Students is selected
  }
  // Handle district and school selection conditionally
  const hasDistricts = districtData && districtData.length > 0;
  const hasSchools = schoolData && schoolData.length > 0;
  
  if (hasDistricts) {
    let districtIds = districtData?.map((item) => item.id);
    overQuery.district_id = districtIds;
  }
  
  if (hasSchools) {
    let schoolIds = schoolData?.map((item) => item.id);
    overQuery.school_id = schoolIds;
  }

  const getQueryResult = () => {
    setLoading(true);
    localStorage.setItem("query", JSON.stringify(overQuery));
    history.push("/recruiter/query-result");
  };

  useEffect(() => {
    if (genderValue) {
      const query = {
        type: "gender",
        name: genderValue.name
      };
      const obj = {
        type: "gender",
        query: query
      };
      
      setSelectedQueries(prev => {
        // Check if gender query already exists to avoid duplicates
        const existingGenderIndex = prev.findIndex(item => item.type === "gender");
        if (existingGenderIndex >= 0) {
          // Replace existing gender query
          const next = [...prev];
          next[existingGenderIndex] = obj;
          return next;
        } else {
          // Add new gender query
          return [...prev, obj];
        }
      });
    }
  }, [genderValue]);

  const removeValueForCheckBox = async (item) => {
    console.log("item frim the remoce", item);
    setGenderValue(undefined);
    
    // Remove from selectedQueries without mutating state
    setSelectedQueries(prev => prev.filter((query, index) => query !== item));
    
    // Remove from configObject without mutating state
    setConfigObject(prev => prev.filter(element => 
      element.value !== "m" && 
      element.value !== "f" && 
      element.value !== "u" &&
      element.value !== "unknown"
    ));
  };

  const handleGenderCheckbox = async (
    value,
    operator = "contains",
    from = "not-advance-query"
  ) => {
    let conf = config && config.filter((item) => item.value === "gender");
    
    // Remove existing gender queries without mutating state
    setSelectedQueries(prev => prev.filter(item => item.type !== "gender"));
    
    setGenderValue(value);
    createConfigForGender(conf, operator, value, from);
  };

  const handleGPASlider = async (value) => {
    let minValue = value[0];
    await setMinGPA(minValue);
    let maxValue = value[1];
    await setMaxGPA(maxValue);
  };

  useEffect(() => {
    if (minGPA !== 0 || maxGPA !== 4) {
      createConfigForGPA();
    }
  }, [minGPA, maxGPA, config]);

  const createConfigForGPA = (min = minGPA, max = maxGPA) => {
    console.log("minGPA", min);
    console.log("maxGPA", max);
    let configggg =
      config && config.filter((element) => element.value === "overall gpa");
    let obj = {
      minValue: min,
      maxValue: max,
    };
    console.log("obj", obj);
    createConfigForGPAAdvance(configggg && configggg[0], "contains", obj);
  };

  const createConfigForGPAAdvanceQuery = (operator, value) => {
    let configggg =
      config && config.filter((element) => element.value === "overall gpa");
    createConfigForGPAAdvance(configggg, operator, value);
  };

  const openAdvanceQuery = () => {
    setOpenAdvanceQueryModal(true);
    // Ensure at least one criteria row exists when opening the modal
    if (noOfAdvanceQuery.length === 0) {
      setAdvanceQueryCount(1);
      setNoOfAdvanceQuery([0]);
    }
  };

  const addMoreAdvanceQuery = () => {
    setAdvanceQueryCount(advanceQueryCount + 1);
    setNoOfAdvanceQuery((prevState) => [...prevState, advanceQueryCount]);
  };

  const selectTab = (value) => {
    if (value === "customQuery") {
      setSelectedTab(value);
      history.push("/recruiter/search-query");
    } else if (value === "schoolQuery") {
      localStorage.removeItem("query");
      setSelectedTab(value);
      history.push("/recruiter/school-query");
    } else if (value === "savedQuery") {
      localStorage.removeItem("query");
      setSelectedTab(value);
      history.push("/recruiter/saved-query");
    } else if (value === "collegeQuery") {
      localStorage.removeItem("query");
      setSelectedTab(value);
      history.push("/recruiter/college-query");
    }
  };

  const saveQuery = () => {
    setOpenSaveQueryModal(true);
  };

  const editQuery = () => {
    console.log("print");
  };

  const clear = () => {
    // Reset selected chips and config
    setSelectedQueries([]);
    setConfigObject([]);

    // Reset basic selectors
    setGenderValue();
    setMinGPA(0);
    setMaxGPA(4);

    // Reset special requirements
    setStudentFirstGeneration(false);
    setUCGreenRequirement(false);

    // Reset any school and district selections - use empty arrays for consistent clearing
    setSchoolData([]);
    setDistrictData([]);

    // Reset collections used to build overQuery
    setSelectedStateQueries([]);
    setSelectedEthnicityQueries([]);
    setSelectedGradeQueries([]);
    setSelectedAcademicsQueries([]);
    setSelectedAthleticsQueries([]);
    setSelectedActivitiesQueries([]);
    setSelectedInterestsQueries([]);
    setSelectedStemQueries([]);

    // Reset any transient advanced selections
    setSelectedThirdParameter([]);
  };

  // Memoized handlers to prevent infinite loops in DistrictSchoolSelector
  const handleDistrictsChange = useCallback((districts) => {
    // Update chosen filter chips for districts
    setDistrictData(districts);
    setSelectedQueries((prev) => {
      const next = prev.filter((i) => i.type !== "district");
      districts.forEach((d) => {
        if (!next.some((i) => i.type === "district" && i?.query?.id === d.id)) {
          next.push({ query: d, type: "district" });
        }
      });
      return next;
    });
    // No coupling to config unless you have a "district" config; skipping by default
  }, []);

  const handleSchoolsChange = useCallback((schools) => {
    // Integrate with existing schoolData logic
    setSchoolData(schools);
    // ensure config object updated for high school if criteria exists
    const conf = config && config.filter((item) => item.value === "high school");
    if (conf && conf.length) {
      createConfig(conf, "contains", schools);
    }
    // add chips
    setSelectedQueries((prev) => {
      const next = [...prev];
      schools.forEach((sch) => {
        if (!next.some((i) => i.type === "high school" && i?.query?.id === sch.id)) {
          next.push({ query: sch, type: "high school" });
        }
      });
      // remove chips no longer selected
      return next.filter((i) => i.type !== "high school" || schools.some((s) => s.id === i.query.id));
    });
  }, [config, createConfig]);

  const dis = viewQueryData?.some((item) => Object.keys(item).length > 0);

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div>
            <div 
              className="query-component-container scrollBar_hidden"
              style={{ 
                marginBottom: selectedTab === "customQuery" ? '40px' : '0px' 
              }}
            >
              <div className="tab-grid">
                <div
                  onClick={() => {
                    dispatch(changeQueryLocation({}));
                    selectTab("customQuery");
                  }}
                  style={{ width: "100%" }}
                  className={` ${selectedTab === "customQuery" ? "active-tab1" : "inactive-tab1"}`}
                >
                  <div className="tab-icon hs-query-icon"></div>
                  <p className="no-margin-bottom">H/S Student Query</p>
                </div>
                <div
                  onClick={() => {
                    dispatch(changeQueryLocation({}));
                    selectTab("schoolQuery");
                  }}
                  style={{ width: "100%" }}
                  className={`${selectedTab === "schoolQuery" ? "active-tab1" : "inactive-tab1"}`}
                >
                  <div className="tab-icon saved-query-icon"></div>
                  <p className="no-margin-bottom">Saved Queries</p>
                </div>
                {/* <div onClick={() => selectTab('savedQuery')} style={{ width: '100%' }} className={' inactive-tab1'}><p className="no-margin-bottom">Saved Queried Results</p></div>
                        <div onClick={() => {}} style={{ width: '100%' }} className={' inactive-tab1'}><p className="no-margin-bottom">Query Columns</p></div> */}
                <div
                  onClick={() => {
                    dispatch(changeQueryLocation({}));
                    selectTab("collegeQuery");
                  }}
                  style={{ width: "100%" }}
                  className={` ${selectedTab === "collegeQuery" ? "active-tab1" : "inactive-tab1"}`}
                >
                  <div className="tab-icon cc-query-icon"></div>
                  <p className="no-margin-bottom">C/C Student Query</p>
                </div>
              </div>
              {loading ? (
                <CustomLoader />
              ) : (
                <div 
                  className="scrollBar_hidden query-main-card" 
                  style={{ 
                    marginTop: '10px', 
                    marginLeft: '2px', 
                    padding: '0px 20px',
                    paddingBottom: selectedTab === "customQuery" ? '60px' : '20px' 
                  }}
                >
                  {/* Clear All at top-right */}
                  <button 
                    onClick={() => clear()} 
                    className="clear-button clear-button--top"
                    disabled={selectedQueries.length === 0 && !genderValue && minGPA === 0 && maxGPA === 4 && !studentFirstGeneration && !ucGreenRequirement}
                  >
                    Clear All
                  </button>
                  <div className="top-border" />
                  <div className="display-selected-query">
                    <p
                      className="no-margin-bottom bold"
                      style={{ textAlign: "center" }}
                    >
                      {queryTittle ? "Query Name - " + queryTittle : ""}
                    </p>
                    <p className="no-margin-bottom bold">Set Query Criteria</p>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "5px",
                      }}
                    >
                      <p className="no-margin-bottom">Choosen Filter:</p>
                      {!openAdvanceQuerySection && (
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            margin: "0px 5px",
                          }}
                        >
                          {selectedQueries &&
                            selectedQueries.map((item) => {
                              return (
                                <div
                                  className="flex"
                                  style={{
                                    margin: "0 5px",
                                    position: "relative",
                                    alignItems: "center",
                                    background: "#009900",
                                    borderRadius: "20px",
                                    paddingRight: "8px",
                                  }}
                                >
                                  <p
                                    style={{
                                      padding: "5px 15px",
                                      background: "#009900",
                                      color: "white",
                                      borderRadius: "20px",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      margin: 0,
                                    }}
                                    className="no-margin-bottom"
                                  >
                                    {item.query.name || item.query.stem_name}
                                  </p>
                                  {item &&
                                    item.query &&
                                    (Array.isArray(item.query)
                                      ? item.query.length > 0
                                      : item.query) && (
                                      <div
                                        className="cursor cancel-icon"
                                        onClick={() => {
                                          if (item.type === "gender") {
                                            removeValueForCheckBox(item);
                                          } else if (item.type === "high school") {
                                            handleCheckBox(item.query, "", item.type);
                                          } else if (item.type === "district") {
                                            // Remove district from districtData and chips
                                            setDistrictData((prev) => prev.filter((d) => d.id !== item.query.id));
                                            setSelectedQueries((prev) => prev.filter((q) => !(q.type === "district" && q.query.id === item.query.id)));
                                          } else if (item.type === "school district") {
                                            // Remove school district from districtData and chips
                                            setDistrictData((prev) => prev.filter((d) => d.id !== item.query.id));
                                            setSelectedQueries((prev) => prev.filter((q) => !(q.type === "school district" && q.query.id === item.query.id)));
                                          } else {
                                            handleCheckBox(item.query, "", item.type);
                                          }
                                        }}
                                      >
                                        <CloseOutlined style={{ fontSize: '12px' }} />
                                      </div>
                                    )}
                                </div>
                              );
                            })}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="bottom-border" />
                  <div style={{ margin: "15px 0px" }}>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "#333333",
                      }}
                    >
                      Set Criteria of Student Search
                    </p>
                    {/* Row 1: School District, High School, Grade */}
                    <div className="col-md-12 row" style={{ marginTop: "15px" }}>
                      <div className="col-md-4">
                        <div className="query-card">
                          <div className="query-title-containers">
                            <p className="bold" style={{ marginBottom: 0 }}>School District</p>
                          </div>
                          <div className="query-card__content">
                            <DistrictSchoolSelector
                              schools={schoolData}
                              districts={districtData}
                              onDistrictsChange={handleDistrictsChange}
                              onSchoolsChange={handleSchoolsChange}
                              showOnlyDistrict={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="query-card">
                          <div className="query-title-containers">
                            <p className="bold" style={{ marginBottom: 0 }}>High School</p>
                          </div>
                          <div className="query-card__content">
                            <DistrictSchoolSelector
                              schools={schoolData}
                              districts={districtData}
                              onDistrictsChange={handleDistrictsChange}
                              onSchoolsChange={handleSchoolsChange}
                              showOnlySchool={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <SingleQuery
                          data={grade}
                          name="grade"
                          config={config}
                          valueWhichExpand={valueWhichExpand}
                          onShowMore={() => {}}
                          handleCheckBox={(value, type) =>
                            handleCheckBox(value, "contains", type)
                          }
                          selectedQueries={selectedQueries && selectedQueries}
                        />
                      </div>
                    </div>

                    {/* Row 2: Gender, Ethnicity, Subject Matter Proficiency */}
                    <div style={{ marginTop: "25px" }} className="col-md-12 row">
                      <div className="col-md-4">
                        <div className="query-card">
                          <div className="query-title-containers ">
                            <p style={{ marginBottom: "0px" }} className="bold">
                              Gender
                            </p>
                          </div>
                          <div className="query-card__content gender-value-container">
                            {genderData &&
                              genderData.map((item, index) => {
                                return (
                                  <div key={index} className="flex">
                                    <input
                                      type="checkbox"
                                      name={item.value}
                                      onChange={() => handleGenderCheckbox(item)}
                                      value={genderValue && genderValue.value}
                                      checked={
                                        genderValue &&
                                        genderValue.value === item.value
                                      }
                                    />
                                    <p
                                      style={{
                                        marginLeft: "10px",
                                        fontSize: "14px",
                                      }}
                                      className="no-margin-bottom"
                                    >
                                      {item.name}
                                    </p>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <SingleQuery
                          loading={loading}
                          data={showEthData}
                          config={config}
                          name="ethnicity"
                          valueWhichExpand={valueWhichExpand}
                          onShowMore={() => {}}
                          handleCheckBox={(value, type) =>
                            handleCheckBox(value, "contains", type)
                          }
                          selectedQueries={selectedQueries && selectedQueries}
                        />
                      </div>
                      <div className="col-md-4">
                        <SingleQuery
                          loading={loading}
                          data={stemData}
                          name="subject matter proficiency"
                          config={config}
                          valueWhichExpand={valueWhichExpand}
                          handleCheckBox={(value, type) =>
                            handleCheckBox(value, "contains", type)
                          }
                          selectedQueries={selectedQueries && selectedQueries}
                        />
                      </div>
                    </div>
                    {/* Row 3: GPA Range (full width) */}
                    <div className="col-md-12 row" style={{ marginTop: '25px' }}>
                      <div className="col-md-12">
                        <div className="query-card query-card--gpa">
                          <GPASlider
                            handleGPASlider={handleGPASlider}
                            minGPA={minGPA}
                            maxGPA={maxGPA}
                            showFourPlus={true}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Row 4: Academics, Athletics, Activities */}
                    <div
                      style={{ marginTop: "25px" }}
                      className="col-md-12 row"
                    >
                      <div className="col-md-4 ">
                        <SingleQuery
                          loading={loading}
                          data={showAcademicsData}
                          name="academics"
                          config={config}
                          valueWhichExpand={valueWhichExpand}
                          onShowMore={() => {}}
                          handleCheckBox={(value, type) =>
                            handleCheckBox(value, "contains", type)
                          }
                          selectedQueries={selectedQueries && selectedQueries}
                        />
                      </div>
                      <div className="col-md-4">
                        <SingleQuery
                          loading={loading}
                          data={showAthleticsData}
                          name="athletics"
                          config={config}
                          valueWhichExpand={valueWhichExpand}
                          onShowMore={() => {}}
                          handleCheckBox={(value, type) =>
                            handleCheckBox(value, "contains", type)
                          }
                          selectedQueries={selectedQueries && selectedQueries}
                        />
                      </div>
                      <div className="col-md-4">
                        <SingleQuery
                          loading={loading}
                          data={showActivitiesData}
                          name="activities"
                          config={config}
                          valueWhichExpand={valueWhichExpand}
                          onShowMore={() => {}}
                          handleCheckBox={(value, type) =>
                            handleCheckBox(value, "contains", type)
                          }
                          selectedQueries={selectedQueries && selectedQueries}
                        />
                      </div>
                    </div>

                    {/* Row 5: Interest, State, blank */}
                    <div
                      style={{ marginTop: "25px" }}
                      className="col-md-12 row"
                    >
                      <div className="col-md-4">
                        <SingleQuery
                          loading={loading}
                          data={showInterestData}
                          name="interests"
                          config={config}
                          valueWhichExpand={valueWhichExpand}
                          onShowMore={() => {}}
                          handleCheckBox={(value, type) =>
                            handleCheckBox(value, "contains", type)
                          }
                          selectedQueries={selectedQueries && selectedQueries}
                        />
                      </div>
                      <div className="col-md-4">
                        <SingleQuery
                          data={showStateData}
                          name="state"
                          config={config}
                          valueWhichExpand={valueWhichExpand}
                          handleCheckBox={(value, type) =>
                            handleCheckBox(value, "contains", type)
                          }
                          onShowMore={() => {}}
                          selectedQueries={selectedQueries && selectedQueries}
                        />
                      </div>
                      <div className="col-md-4">
                        {/* Blank space */}
                      </div>
                    </div>

                    {/* Row 6: First Generation Student and A-G On Track Students (after State and Interests) */}
                    <div
                      style={{ marginTop: "25px" }}
                      className="col-md-12 row"
                    >
                      <div className="col-md-6">
                        <div className="query-card special-requirements-card">
                          <div className="query-card__content">
                            <div className="flex" style={{ alignItems: "center" }}>
                              <input
                                type="checkbox"
                                checked={studentFirstGeneration}
                                onChange={() =>
                                  handleCheckBox(
                                    studentFirstGenerationValue,
                                    "contains",
                                    "student first generation"
                                  )
                                }
                              />
                              <p className="no-margin-bottom bold">
                                First Generation Student
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="query-card special-requirements-card">
                          <div className="query-card__content">
                            <div className="flex" style={{ alignItems: "center" }}>
                              <input
                                type="checkbox"
                                checked={ucGreenRequirement}
                                onChange={() =>
                                  handleCheckBox(
                                    ucGreenRequirementValue,
                                    "contains",
                                    "uc_status"
                                  )
                                }
                              />
                              <p className="no-margin-bottom bold">
                                A-G On Track Students
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {openAdvanceQuerySection && (
                      <button
                        onClick={() => addMoreAdvanceQuery()}
                        className="query-button font bold"
                      >
                        +Add Additional Criteria
                      </button>
                    )}
                    {openAdvanceQuerySection &&
                      noOfAdvanceQuery.map((item, index) => (
                        <div key={item}>
                          <AdvanceQueryCriteria
                            interestData={interestData}
                            activitiesData={activitiesData}
                            academicsData={academicsData}
                            athleticsData={athleticsData}
                            ethnicityData={ethnicity}
                            stemData={stemData}
                            config={config}
                            createConfig={createConfig}
                            handleCheckBox={handleCheckBox}
                            clearAll={clearAll}
                            selectedThirdParameter={selectedThirdParameter}
                            setSelectedThirdParameter={
                              setSelectedThirdParameter
                            }
                            item={item}
                            createConfigForGPAAdvanceQuery={
                              createConfigForGPAAdvanceQuery
                            }
                            onCloseAdvanceQuery={() =>
                              onCloseAdvanceQuery(index)
                            }
                            showClose={index > 0}
                          />
                        </div>
                      ))}
                    <div
                      style={{
                        borderBottom: "3px solid black",
                        marginTop: "15px",
                      }}
                    />
                    
                    {/* Bottom buttons row with new design */}
                    <div
                      style={{ margin: "15px 0" }}
                      className="bottom-buttons-row"
                    >
                      <button
                        onClick={() => openAdvanceQuerySection ? getQueryResult() : getQueryResult()}
                        className="btn-run-query1"
                        style={{ opacity: queryTittle ? 0.5 : 1 }}
                        disabled={queryTittle}
                      >
                        <img src={require("../../assets/images/recruiterQuery/white-eye.png")} alt="" className="btn-icon" />
                        {openAdvanceQuerySection ? "Run Advanced Query" : "Run Query"}
                      </button>
                      
                      {!dis && (
                        <button
                          onClick={() => saveQuery()}
                          className="btn-save-query"
                        >
                          <img src={require("../../assets/images/recruiterQuery/blue-eye.png")} alt="" className="btn-icon" />
                          Save Query
                        </button>
                      )}
                      
                      <button
                        onClick={() => resetQueryCriteria()}
                        className="btn-reset-query"
                        disabled={(selectedQueries?.length || 0) === 0 && !genderValue && minGPA === 0 && maxGPA === 4}
                      >
                        <img src={require("../../assets/images/recruiterQuery/white-eye.png")} alt="" className="btn-icon" />
                        Reset Query
                      </button>
                      
                      <button
                        onClick={() => openAdvanceQuery()}
                        className="btn-advance-query"
                      >
                        <img src={require("../../assets/images/recruiterQuery/orange-eye.png")} alt="" className="btn-icon" />
                        Add Advanced Query Criteria
                      </button>
                    </div>
                    
                    {openAdvanceQuerySection && (
                      <button
                        onClick={() => addMoreAdvanceQuery()}
                        className="query-button font bold"
                      >
                        +Add Additional Criteria
                      </button>
                    )}
                    {openAdvanceQuerySection &&
                      noOfAdvanceQuery.map((item, index) => (
                        <div key={item}>
                          <AdvanceQueryCriteria
                            interestData={interestData}
                            activitiesData={activitiesData}
                            academicsData={academicsData}
                            athleticsData={athleticsData}
                            ethnicityData={ethnicity}
                            stemData={stemData}
                            config={config}
                            createConfig={createConfig}
                            handleCheckBox={handleCheckBox}
                            clearAll={clearAll}
                            selectedThirdParameter={selectedThirdParameter}
                            setSelectedThirdParameter={
                              setSelectedThirdParameter
                            }
                            item={item}
                            createConfigForGPAAdvanceQuery={
                              createConfigForGPAAdvanceQuery
                            }
                            onCloseAdvanceQuery={() =>
                              onCloseAdvanceQuery(index)
                            }
                            showClose={index > 0}
                          />
                        </div>
                      ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          {openSaveQueryModal && (
            <SaveModal
              openSaveModal={openSaveQueryModal}
              setOpenSaveModal={setOpenSaveQueryModal}
              from="query-page"
              saveForCollegeQuery={overQuery && overQuery}
              saveForSiembra={saveForSiembra}
              inputValueForSave={inputValueForSave}
              setInputValueForSave={setInputValueForSave}
            />
          )}
          {openConfirmationForSiembra && (
            <ConfirmationDialog
              isOpen={openConfirmationForSiembra}
              setIsOpen={setOpenConfirmationForSiembra}
              query={configObject && configObject}
              inputValue={inputValueForSave}
              openErrorModal={openExistingErrorModal}
              setQuery={setConfigObject}
              setOpenErrorModal={setOpenExistingErrorModal}
              setInputValue={setInputValueForSave}
            />
          )}
          {openExistingErrorModal && (
            <ErrorModal
              openErrorModal={openExistingErrorModal}
              setOpenErrorModal={setOpenExistingErrorModal}
            />
          )}
          {openAdvanceQueryModal && (
            <div className="advance-query-modal-overlay">
              <div className="advance-query-modal">
                <div className="advance-query-modal-header">
                  <h3>Advanced Query Criteria</h3>
                  <button
                    className="modal-close-btn"
                    onClick={() => setOpenAdvanceQueryModal(false)}
                    aria-label="Close Advanced Query Modal"
                  >
                    <svg
                      className="close-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M18 6L6 18" stroke="#333" strokeWidth="2" strokeLinecap="round" />
                      <path d="M6 6L18 18" stroke="#333" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                  </button>
                </div>
                <div className="advance-query-modal-content">
                  {/* Render dynamic criteria rows */}
                  {noOfAdvanceQuery.length === 0 && (
                    <div className="criteria-container">
                      <AdvanceQueryCriteria
                        interestData={interestData}
                        activitiesData={activitiesData}
                        academicsData={academicsData}
                        athleticsData={athleticsData}
                        ethnicityData={ethnicity}
                        stemData={stemData}
                        config={config}
                        createConfig={createConfig}
                        handleCheckBox={handleCheckBox}
                        clearAll={clearAll}
                        selectedThirdParameter={selectedThirdParameter}
                        setSelectedThirdParameter={setSelectedThirdParameter}
                        item={0}
                        createConfigForGPAAdvanceQuery={createConfigForGPAAdvanceQuery}
                        onCloseAdvanceQuery={() => setNoOfAdvanceQuery([])}
                        showClose={false}
                      />
                    </div>
                  )}
                  {noOfAdvanceQuery.length > 0 && (
                    <div className="criteria-container">
                      {noOfAdvanceQuery.map((item, index) => (
                        <div key={item} className="criteria-row">
                          <AdvanceQueryCriteria
                            interestData={interestData}
                            activitiesData={activitiesData}
                            academicsData={academicsData}
                            athleticsData={athleticsData}
                            ethnicityData={ethnicity}
                            stemData={stemData}
                            config={config}
                            createConfig={createConfig}
                            handleCheckBox={handleCheckBox}
                            clearAll={clearAll}
                            selectedThirdParameter={selectedThirdParameter}
                            setSelectedThirdParameter={setSelectedThirdParameter}
                            item={item}
                            createConfigForGPAAdvanceQuery={createConfigForGPAAdvanceQuery}
                            onCloseAdvanceQuery={() => onCloseAdvanceQuery(index)}
                            showClose={index > 0}
                          />
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="add-criteria-section">
                    <button className="add-additional-btn btn-run-query1" onClick={addMoreAdvanceQuery}>
                      + Add Additional Criteria
                    </button>
                  </div>

                  <div className="modal-divider" />

                  <div className="modal-buttons">
                    {/* Reuse bottom row styles; compute emptiness for disabled states inline */}
                    <button
                      className="btn-run-query1"
                      onClick={() => {
                        setOpenAdvanceQueryModal(false);
                        getQueryResult();
                      }}
                      disabled={
                        queryTittle ||
                        ((selectedQueries?.length || 0) === 0 && !genderValue && minGPA === 0 && maxGPA === 4)
                      }
                    >
                      <img
                        src={require("../../assets/images/recruiterQuery/white-eye.png")}
                        alt=""
                        className="btn-icon"
                      />
                      Run Advanced Query
                    </button>

                    {!dis && (
                      <button
                        className="btn-save-query"
                        onClick={() => {
                          setOpenAdvanceQueryModal(false);
                          saveQuery();
                        }}
                        disabled={
                          (selectedQueries?.length || 0) === 0 &&
                          !genderValue &&
                          minGPA === 0 &&
                          maxGPA === 4
                        }
                      >
                        <img
                          src={require("../../assets/images/recruiterQuery/blue-eye.png")}
                          alt=""
                          className="btn-icon"
                        />
                        Save Query
                      </button>
                    )}

                    <button
                      className="btn-reset-query"
                      onClick={() => {
                        setOpenAdvanceQueryModal(false);
                        resetQueryCriteria();
                      }}
                      disabled={
                        (selectedQueries?.length || 0) === 0 &&
                        !genderValue &&
                        minGPA === 0 &&
                        maxGPA === 4
                      }
                    >
                      <img
                        src={require("../../assets/images/recruiterQuery/white-eye.png")}
                        alt=""
                        className="btn-icon"
                      />
                      Reset Query
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
         
        </div>
      </div>
    </Fragment>
  );
};
export default QueryComponent;

// Modal markup is rendered conditionally within the component's return below
